import ArticleGeneratorView from "@features/tools/view/article-generator-view";

const ArticleGenerator = () => {
  return <ArticleGeneratorView />;
};

export default ArticleGenerator;
